/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BriefDetailResource } from './';
import {
    BriefDetailResourceFromJSON,
    BriefDetailResourceFromJSONTyped,
    BriefDetailResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProposalResource
 */
export interface ProposalResource {
    /**
     * 
     * @type {string}
     * @memberof ProposalResource
     */
    conversationId: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalResource
     */
    title: string;
    /**
     * 
     * @type {BriefDetailResource}
     * @memberof ProposalResource
     */
    briefDetail?: BriefDetailResource;
}

/**
 * Check if a given object implements the ProposalResource interface.
 */
export function instanceOfProposalResource(value: object): value is ProposalResource {
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function ProposalResourceFromJSON(json: any): ProposalResource {
    return ProposalResourceFromJSONTyped(json, false);
}

export function ProposalResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalResource {
    if (json == null) {
        return json;
    }
    return {
        
        'conversationId': json['conversationId'],
        'title': json['title'],
        'briefDetail': json['briefDetail'] == null ? undefined : BriefDetailResourceFromJSON(json['briefDetail']),
    };
}

export function ProposalResourceToJSON(value?: ProposalResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'conversationId': value['conversationId'],
        'title': value['title'],
        'briefDetail': BriefDetailResourceToJSON(value['briefDetail']),
    };
}

